import { BulkDeleteVisitorsPayload, UserIdentityProvider, Visitor } from 'graphql/generated/graphqlTypes';

export interface DeletableUsers {
  deletableVisitorIds: string[];
  entraUsersCount: number;
}

export const getDeletableUsers = (selectedVisitors: Visitor[]): DeletableUsers => {
  const deletableVisitorIds = selectedVisitors
    .filter(
      ({ identityProvider }) =>
        identityProvider === UserIdentityProvider.Internal || identityProvider === UserIdentityProvider.Cognito
    )
    .map(({ id }) => id);
  const entraUsersCount = selectedVisitors.filter(
    ({ identityProvider }) => identityProvider === UserIdentityProvider.Entra
  ).length;

  return { deletableVisitorIds, entraUsersCount };
};

export const hasDeletedAllVisitors = (payload: BulkDeleteVisitorsPayload, visitorIds: string[]) => {
  const deletedVisitorIds = new Set(payload.deletedVisitorIds);

  return payload.errors.length === 0 && visitorIds.every((visitorId) => deletedVisitorIds.has(visitorId));
};
